import { RecentTransactionsRedesign } from 'pages/Cash/components/RecentTransactionsRedesign/RecentTransactionsRedesign';

const RecentCashTransactions = props => {
  if (props.showRecentTransactions) {
    return (
      <RecentTransactionsRedesign
        modulePosition={props.modulePosition}
        {...props.transactions}
      />
    );
  } else {
    return '';
  }
};

export default RecentCashTransactions;
